var _defs, _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaignoireMauvaisePosition1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "baignoire",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 891 427.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-width:5px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{stroke:#fff;stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bagnoire mauvaise r\xE9ponse 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467,1283h576s179,11,179-303H336C336,1146,384,1283,467,1283Z",
    transform: "translate(-333.5 -870.69)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 437.5,
    y: 235.31,
    width: 297,
    height: 148
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mauvaise_1",
    "data-name": "mauvaise 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M602,1248c-20,0-17,47,10,47H798c18,0,35-2.63,35-20.81S734,1145,734,1145l127-47,108,134c9.65,24.67,55.65,6.67,46-18l-72-130c-11.68-63-50-144-108-112l-162,74c-51,44-53.5,85.5-21,118l75,75Z",
    transform: "translate(-333.5 -870.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 654.84,
    cy: 82.66,
    r: 79.66
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaignoireMauvaisePosition1);
export default __webpack_public_path__ + "static/media/baignoire_mauvaise_position_1.59022a0206d137f698b7713569621358.svg";
export { ForwardRef as ReactComponent };